<template>
  <div>
    <div class="header-main">
      <h1 class="py-4 page-title-main">
        {{ $t('routeTitles.users.usersCrmCommon') }}
      </h1>
    </div>
    <template>
      <div class="px-main">
        <v-tabs v-model="tab" class="t-tab-custom">
          <v-tab v-for="(item, i) in items" :key="i" :to="item.to">{{
            item.title
          }}</v-tab>
        </v-tabs>
      <slot name="default" />
      </div>
    </template>
  </div>
</template>

<script>
import { checkPermissionTab } from '@/utils/permissions'

export default {
  name: 'BaseUsers',
  data () {
    return {
      tab: null,
      items: [],
      itemsTmp: [
        {
          title: this.$t('routeTitles.users.information'),
          to: '/users/information',
          pathRoot: '/users/information',
          order: 1
        },
        {
          title: this.$t('routeTitles.users.userList'),
          to: '/users/list',
          pathRoot: '/users/list',
          order: 2
        },
        {
          title: this.$t('routeTitles.users.userRights'),
          to: '/users/rights',
          pathRoot: '/users/rights',
          order: 3
        }
      ]
    }
  },
  components: {

  },
  mounted () {
    this.checkPerTab()
  },
  methods: {
    checkPermissionTab,
    checkPerTab () {
      let itemCheck = this.checkPermissionTab(this.itemsTmp)
      itemCheck = [...new Set(itemCheck)]
      itemCheck.sort((a, b) => a.order - b.order)
      this.items = itemCheck
    }
  }
}
</script>

<style lang="scss">

</style>
